export default "__VITE_ASSET__Tyfe6qmu__"